import React, { Component } from "react";

class TopStatus extends Component {
  render() {
    const { count, module } = this.props;
    return (
      <div className="module-records-count">
        Showing
        <span className="module-records-count__counter">{count}</span>
        {module}.
      </div>
    );
  }
}

export default TopStatus;
